exports.f = require('./_wks');



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/_wks-ext.js